export enum ForecastSourceLabelEnum {
  AG2 = 'AG2',
  GFS_OP = 'GFS OP',
  MF_GFS_OP = 'MF GFS OP',
  GFS_ENS = 'GFS ENS',
  ECMWF_OP = 'ECMWF OP',
  MF_ECMWF_OP = 'MF ECMWF OP',
  ECMWF_ENS = 'ECMWF ENS',
  GEM_OP = 'GEM OP',
  GEM_ENS = 'GEM ENS',
  ECMWF_AIFS = 'ECMWF AIFS',
  ECMWF_AIFS_ENS = 'ECMWF AIFS ENS',
}
